import { render } from "./insure-daily-bill-info.vue?vue&type=template&id=7d96c261&scoped=true&ts=true"
import script from "./insure-daily-bill-info.vue?vue&type=script&lang=ts"
export * from "./insure-daily-bill-info.vue?vue&type=script&lang=ts"

import "./insure-daily-bill-info.vue?vue&type=style&index=0&id=7d96c261&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d96c261"]])

export default __exports__